import { styled } from '@mui/material/styles';
import { Typography } from '../../Typography';

export const TypographyStyled = styled(Typography)`
  margin-bottom: 12px;
`;
